import React from 'react';
import { motion } from 'framer-motion';
export function PainBlock() {
  const pains = ['Sobrepensás todo lo relacionado con tu bebé', 'Tenés miedo de hacerlo mal', 'Te abruma la cantidad de información', 'No sabés qué es normal y qué no', 'Sentís ansiedad por el parto o el postparto', 'Buscás respuestas constantemente', 'Necesitás sentirte más segura', 'Querés vivir esta etapa con más tranquilidad'];
  return <section className="py-20 md:py-28 bg-sage-light/30 relative overflow-hidden" data-id="element-249">
      <div className="absolute top-20 right-10 grid grid-cols-4 gap-2 opacity-30" data-id="element-250">
        {[...Array(16)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-sage" data-id="element-251"></div>)}
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16 max-w-4xl mx-auto" data-id="element-253">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-254">
            🌸 ¿TE PASA ESTO?
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-8" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-255">
            La maternidad viene con más miedo y dudas de las que imaginabas
          </h2>
          <p className="font-serif italic text-xl md:text-2xl text-peach-dark mb-8" data-id="element-256">
            Y eso no significa que estés haciendo algo mal.
          </p>

          <div className="space-y-4 text-lg text-text-muted max-w-2xl mx-auto" data-id="element-257">
            <p data-id="element-258">
              Muchas veces el verdadero agotamiento no viene solo del embarazo.
              Viene de sentir miedo constante, no saber qué es normal,
              sobreinformarte, y sentir que nadie te explica realmente las cosas
              con calma.
            </p>
            <p className="text-text-dark font-medium pt-2" data-id="element-259">
              No es falta de capacidad. Es falta de acompañamiento claro.
            </p>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 mb-16 max-w-4xl mx-auto" data-id="element-260">
          {pains.map((pain, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.05
        }} className="flex items-center gap-3 bg-white p-5 rounded-2xl shadow-sm border border-sage-light" data-id="element-261">
              <span className="text-xl" data-id="element-262">🌸</span>
              <span className="text-text-dark" data-id="element-263">{pain}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-[2.5rem] p-10 md:p-16 text-center shadow-lg border border-peach-light max-w-3xl mx-auto" data-id="element-264">
          <p className="font-serif italic text-2xl md:text-4xl text-peach-dark leading-relaxed" data-id="element-265">
            "No necesitás saberlo todo para ser una buena mamá. Pero sí
            necesitás sentirte acompañada."
          </p>
        </motion.div>
      </div>
    </section>;
}